import request from '@/config/axios'

// 烂尾单分析 VO
export interface OrderStallAnalysisVO {
  id?: number // 编号
  customerId?: number // 客户编号
  customerName?: string // 客户名称
  orderId?: number // 项目（订单）编号
  projectName?: string // 项目名称（取自归属订单）
  orderNo?: string // 归属订单单号
  contactName?: string // 联系人
  reasonId?: number // 原因（烂尾单原因分类编号）
  reasonName?: string // 原因名称
  reasonDetail?: string // 原因详细说明
  solution?: string // 解决方案
  creator?: string // 申请人（创建人编号）
  creatorName?: string // 申请人名字
  createTime?: Date // 创建时间
}

// 烂尾单分析 API
export const OrderStallAnalysisApi = {
  // 查询烂尾单分析分页
  getOrderStallAnalysisPage: async (params: any) => {
    return await request.get({ url: `/crm/order-stall-analysis/page`, params })
  },

  // 查询烂尾单分析详情
  getOrderStallAnalysis: async (id: number) => {
    return await request.get({ url: `/crm/order-stall-analysis/get?id=` + id })
  },

  // 新增烂尾单分析
  createOrderStallAnalysis: async (data: OrderStallAnalysisVO) => {
    return await request.post({ url: `/crm/order-stall-analysis/create`, data })
  },

  // 修改烂尾单分析
  updateOrderStallAnalysis: async (data: OrderStallAnalysisVO) => {
    return await request.put({ url: `/crm/order-stall-analysis/update`, data })
  },

  // 删除烂尾单分析
  deleteOrderStallAnalysis: async (id: number) => {
    return await request.delete({ url: `/crm/order-stall-analysis/delete?id=` + id })
  },

  // 导出烂尾单分析
  exportOrderStallAnalysis: async (params: any) => {
    return await request.download({ url: `/crm/order-stall-analysis/export`, params })
  },

  // 下载烂尾单分析导入模板
  getOrderStallAnalysisImportTemplate: async () => {
    return await request.download({ url: `/crm/order-stall-analysis/get-import-template` })
  },

  // 导入烂尾单分析
  importOrderStallAnalysis: async (data: any, updateSupport: boolean) => {
    return await request.upload({
      url: `/crm/order-stall-analysis/import`,
      params: { updateSupport },
      data
    })
  }
}
